import type { FC } from 'react';
import React, { useContext } from 'react';

import { ContentTraverserContext, withRicosNodeContext } from './../../../../../ricos-context';
import type { NodeViewRendererProps } from './../../../../../ricos-types';

const Text: FC<NodeViewRendererProps> = ({ node }) => {
  const { text } = node.textData || {};
  const { nodeViewDecorators } = useContext(ContentTraverserContext);
  if (text && text !== '') {
    return <span>{nodeViewDecorators.applyTextual(node) || text}</span>;
  }
  return <br role="presentation" />;
};

const TextRenderer = (props: NodeViewRendererProps & { parentId: string }) => {
  const { parentId, nodeIndex } = props;
  const key = `${parentId}-text-node-${nodeIndex}`;
  return <Text key={key} {...props} />;
};

export default withRicosNodeContext(TextRenderer);
